// use token for API calls here

// axios.defaults.headers.common["Authorization"] =
//     `Bearer ${localStorage.getItem("token")}`;

function AdminDashboard() {
    return (
        <div>
            hai you've reached the admin dashboard
            
        </div>
    )
}

export default AdminDashboard;